import api from 'services/api';
import { BuildingProps } from './building-service';

/* The AccountProps type represents the properties of an account, including its UUID, name, contract start and end dates, activity status, 
and associated buildings. */
export type AccountProps = {
  uuid?: string;
  name: string;
  contractEndDate: string | number | Date;
  contractStartDate?: string | number | Date;
  isActive?: boolean;
  buildings?: BuildingProps[];
};

/* The function `findAllAccounts` is an asynchronous function that makes a GET request to the `/apiv1/accounts/` endpoint and returns 
all the accounts data from the response. */
const findAllAccounts = async () => {
  const response = await api.get<AccountProps[]>('/apiv1/accounts/');
  return response?.data;
};

/* The function `findAccountById` retrieves an account object from an API based on the provided UUID. */
const findAccountById = async (uuid: string | undefined) => {
  const response = await api.get<AccountProps>(`/apiv1/account/${uuid}/`);
  return response?.data;
};

/* The function creates a new account by making a POST request to the '/apiv1/account/' endpoint with the provided account data. */
const createAccount = async (newAccount: AccountProps) => {
  const response = await api.post<AccountProps>('/apiv1/account/', newAccount);
  return response?.data;
};

/* The function `updateAccount` is an asynchronous function that updates an account using a PUT request to an API endpoint. */
const updateAccount = async (uuid: string | undefined, updatedAccount: AccountProps) => {
  const response = await api.put<AccountProps>(`/apiv1/account/${uuid}/`, updatedAccount);
  return response?.data;
};

/* The function `deleteAccountById` is an asynchronous function that deletes an account by its UUID using an API call. */
const deleteAccountById = async (uuid: string | undefined) => {
  const response = await api.delete<AccountProps>(`/apiv1/account/${uuid}/`);
  return response?.data;
};

const AccountService = {
  findAllAccounts,
  findAccountById,
  createAccount,
  updateAccount,
  deleteAccountById
};

export default AccountService;
